import { FC, ReactNode } from "react";
import { useSnapshot } from "valtio";
import * as Toast from "@radix-ui/react-toast";
import { userStore } from "src/js/stores/user/store";
import { removeNotification } from "src/js/stores/user/actions/removeNotification";
import { Notification } from "react-migration/components/NotificationV2";

export const NotificationsProvider: FC<{ duration?: number; children: ReactNode }> = ({ duration, children }) => {
  const { user } = useSnapshot(userStore);
  const toasts = user.toast_notifications;

  return (
    <Toast.Provider swipeDirection="right" duration={duration}>
      {children}
      {toasts.map((toast) => (
        <Notification
          key={toast.id}
          id={toast.id}
          title={toast.title}
          description={toast.description}
          type={toast.type}
          duration={toast.duration}
          closable={true}
          onClose={() => removeNotification(toast.id)}
        />
      ))}
      <Toast.Viewport className="fixed bottom-4 left-1/2 transform -translate-x-1/2 flex flex-col gap-2 items-center z-50" />
    </Toast.Provider>
  );
};
